const MUTATION_TYPE = {
  setNots: 'setNots',
  setUnreadNots: 'setUnreadNots',
  setTotalNots: 'setTotalNots',
  setLatestNots: 'setLatestNots',
  setCurrentPage: 'setCurrentPage',
  clearNots: 'clearNots'
}

const ACTION_TYPE = {
  fetchNots: 'fetchNots',
  fetchUnreadNots: 'fetchUnreadNots',
  fetchLatestNots: 'fetchLatestNots',
  clearNots: 'clearNots',
  changePage: 'changePage'
}

const GETTER_TYPE = {
  getNots: 'getNots',
  getUnreadNots: 'getUnreadNots',
  getLatestNots: 'getLatestNots',
  getTotal: 'getTotal',
  getPerPage: 'getPerPage',
  getCurrentPage: 'getCurrentPage'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
